import { Link } from 'react-router-dom';

const CATEGORIES = [
  { label: '电影', desc: '院线大片与经典佳作', icon: 'ri-movie-2-line', to: '/category/movie' },
  { label: '电视剧', desc: '追更不断的热播剧集', icon: 'ri-tv-2-line', to: '/category/tv' },
  { label: '日韩剧', desc: '日韩人气话题作品', icon: 'ri-flower-line', to: '/category/tv/韩国' },
  { label: '华语剧', desc: '中国与港台优质剧集', icon: 'ri-book-2-line', to: '/category/tv/中国' },
  { label: '综艺', desc: '轻松有趣的节目合集', icon: 'ri-mic-line', to: '/category/hot' },
  { label: '悬疑犯罪', desc: '烧脑反转一次看到爽', icon: 'ri-search-eye-line', to: '/category/movie/悬疑' },
  { label: '浪漫爱情', desc: '治愈暖心的爱情故事', icon: 'ri-heart-3-line', to: '/category/movie/爱情' },
  { label: '科幻奇幻', desc: '想象无界的未来世界', icon: 'ri-planet-line', to: '/category/movie/科幻' },
];

export default function CategoryEntry() {
  return (
    <section className="w-full px-4 md:px-8 py-8 md:py-10">
      <div className="flex items-end justify-between mb-5">
        <div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">分类快捷入口</h2>
          <p className="mt-1 text-sm text-foreground-500">按你的口味，快速找到想看的影视作品</p>
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-8 gap-3 md:gap-4">
        {CATEGORIES.map((cat) => (
          <Link
            key={cat.label}
            to={cat.to}
            className="group p-4 rounded-lg bg-background-100 border border-background-200 hover:border-primary-400 hover:bg-background-200/70 cursor-pointer transition-colors"
          >
            <span className="w-11 h-11 rounded-md bg-primary-500/15 text-primary-500 flex items-center justify-center mb-3 group-hover:bg-primary-500 group-hover:text-background-950 transition-colors">
              <i className={`${cat.icon} text-xl`}></i>
            </span>
            <h3 className="text-sm font-semibold text-foreground-950">{cat.label}</h3>
            <p className="mt-1 text-xs text-foreground-500 leading-5">{cat.desc}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}